import { useState, useEffect } from 'react';

const useImageLoader = (lowQualitySrc, highQualitySrc) => {
  const [imageSrc, setImageSrc] = useState(lowQualitySrc); // Start with low-quality image

  useEffect(() => {
    const img = new Image();
    img.src = highQualitySrc;
    img.onload = () => {
      setImageSrc(highQualitySrc); // Replace with high-quality image once loaded
    };
  }, [highQualitySrc]);

  return imageSrc;
};

export default useImageLoader;
